<div class="row mb-3">
  <div class="col-12">
    <app-form-label [label]="'PUSHNOTIFICATIONSETTINGS' | translate"></app-form-label>
  </div>
  <div class="col-12">
    @if (automaticResetDays !== null) {
      <app-content class="my-1" [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{ 'PUSHNOTIFICATIONSSETTINGSDEACTIVATIONFORDAYS' | translate }} {{ ' : ' }} {{ automaticResetDays }}</app-content>
    }
  </div>
  <div class="col-12">
    <app-browser-notifications></app-browser-notifications>
  </div>
  <div class="row align-items-center my-2">
    <div class="col-12 d-flex align-items-center">
      <span class="me-auto pe-2 text-muted">
        <app-form-label [type]="'content'" [label]="'PUSHSETTINGENABLEALL' | translate" [class]="'text-uppercase'"></app-form-label>
      </span>
      <div class="flex-shrink-0 d-flex align-items-center">
        <app-form-switch [fG]="fG" [fCN]="'push_enable_all'"></app-form-switch>
      </div>
    </div>
  </div>
</div>

<div class="row align-items-center mb-3">
  <div class="row align-items-center mb-2">
    <div class="col-12  d-flex align-items-center">
      <span class="me-auto pe-2 text-muted">
        <app-form-label [type]="'content'" [label]="'PUSHSETTINGENABLEMOBILE' | translate"></app-form-label>
      </span>
      <div class="flex-shrink-0 d-flex align-items-center">
        <app-form-switch [fG]="fG" [fCN]="'push_enable_mobile'"></app-form-switch>
      </div>
    </div>
  </div>
  <div class="row align-items-center mb-2">
    <div class="col-12 d-flex align-items-center push-toggle-row">
      <span class="me-auto pe-2 text-muted">
        <app-form-label [type]="'content'" [label]="'PUSHSETTINGENABLEWEBSITE' | translate"></app-form-label>
      </span>
      <div class="warning-icon-slot">
        @if (firebase.notificationState() !== 'granted' && fG.controls['push_enable_browser']?.value === true) {
          <app-tooltip
            [icon]="'warning_amber'"
            [iconClass]="'fs-6 px-2 text-danger'"
            [text]="notificationsTooltipText()"
            [width]="'300px'"
            [height]="'100px'"
            [cssClass]="'helpTooltip p-2'"
            [opensOn]="'Auto'">
          </app-tooltip>
        }
      </div>
      <div class="flex-shrink-0 d-flex align-items-center">
        <app-form-switch [fG]="fG" [fCN]="'push_enable_browser'"></app-form-switch>
      </div>
    </div>
  </div>
  <div class="row align-items-center mb-2">
    <div class="col-12 d-flex align-items-center push-toggle-row">
      <span class="me-auto pe-2 text-muted">
        <app-form-label [type]="'content'" [label]="'PUSHSETTINGENABLECHAT' | translate"></app-form-label>
      </span>
      <div class="warning-icon-slot">
        @if (firebase.notificationState() !== 'granted' && fG.controls['push_enable_chat']?.value === true) {
          <app-tooltip
            [icon]="'warning_amber'"
            [iconClass]="'fs-6 px-2 text-danger'"
            [text]="notificationsTooltipText()"
            [width]="'300px'"
            [height]="'100px'"
            [cssClass]="'helpTooltip p-2'"
            [opensOn]="'Auto'">
          </app-tooltip>
        }
      </div>
      <div class="flex-shrink-0 d-flex align-items-center">
        <app-form-switch [fG]="fG" [fCN]="'push_enable_chat'"></app-form-switch>
      </div>
    </div>
  </div>
</div>
<div class="row mb-3">
  <div class="col-12">
    <app-form-label [label]="'EMAILNOTIFICATIONSETTINGS' | translate"></app-form-label>
  </div>
</div>
<div class="row align-items-center mb-3">
  <div class="row align-items-center mb-2">
    <div class="col-12 d-flex align-items-center">
      <span class="me-auto pe-2 text-muted">
        <app-form-label [type]="'content'" [label]="'PUSHSETTINGENABLEEMAIL' | translate"></app-form-label>
      </span>
      <div class="flex-shrink-0 d-flex align-items-center">
        <app-form-switch [fG]="fG" [fCN]="'push_enable_email'"></app-form-switch>
      </div>
    </div>
  </div>
  @if (showCalendarEmailSetting) {
    <div class="row align-items-center mb-2">
      <div class="col-12 d-flex align-items-center">
        <span class="me-auto pe-2 text-muted">
          <app-form-label [type]="'content'" [label]="'PUSHSETTINGENABLECALENDAREMAIL' | translate"></app-form-label>
        </span>
        <div class="flex-shrink-0 d-flex align-items-center">
          <app-form-switch [fG]="fG" [fCN]="'push_enable_calendar_email'"></app-form-switch>
        </div>
      </div>
    </div>
  }
</div>
